// extracted by mini-css-extract-plugin
export default {"vertical":"Delimiter_vertical__BBC5k","horizontal":"Delimiter_horizontal__VuxX+"};